import { render, staticRenderFns } from "./fileExtraction.vue?vue&type=template&id=10846edf&scoped=true&"
import script from "./fileExtraction.vue?vue&type=script&lang=ts&"
export * from "./fileExtraction.vue?vue&type=script&lang=ts&"
import style0 from "./fileExtraction.vue?vue&type=style&index=0&id=10846edf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10846edf",
  null
  
)

export default component.exports